import { isDevelopment } from '../dev';
import { withParams } from './with-params';

function withDev(url: string, dev?: string): string {
  const _dev = dev || process.env.REACT_APP_DEV_PARAM || undefined;
  if (isDevelopment && _dev) {
    return withParams(url, { dev: _dev });
  }
  return url;
}

export { withDev };
